module.exports = __webpack_public_path__ + "img/passHide.61024c94.svg";